import { mapGetters } from "vuex";
import axios from "axios";
import Vue from "vue";
import { canDoModule } from "./panelModules";

// v-can:add="'blogs'" hides the element unless the user's position may do
// that action in the module (also v-can:edit, v-can:delete; the value can be
// an array of module keys for a screen shared by modules)
const applyCan = (el, binding, vnode) => {
  // null means no restriction (e.g. a user saving their own profile)
  const allowed = binding.value == null || vnode.context.canDo(binding.value, binding.arg || "view");
  el.style.display = allowed ? "" : "none";
};

const mixin = {
  install(Vue) {
    Vue.directive("can", { bind: applyCan, componentUpdated: applyCan });
    Vue.mixin({
      methods: {
        // Define your universal function
        encryptIt(string) {
          const CryptoJS = require("crypto-js");
          const secretKey = CryptoJS.enc.Utf8.parse(
            "12345678123456781234567812345678"
          );
          const iv = CryptoJS.enc.Utf8.parse("Ef7ix7ETPgghl3vP");
          let encrypted = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(string),
            secretKey,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
          ).toString();
          return encrypted.replace(/[+]/g, "-").replace(/[/]/g, "_");
        },
        decryptIt(string) {
          const CryptoJS = require("crypto-js");
          const secretKey = CryptoJS.enc.Utf8.parse(
            "12345678123456781234567812345678"
          );
          const iv = CryptoJS.enc.Utf8.parse("Ef7ix7ETPgghl3vP");
          string = string.replace(/[-]/g, "+").replace(/[_]/g, "/");
          let encrypted = CryptoJS.AES.decrypt(string, secretKey, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }).toString(CryptoJS.enc.Utf8);
          return encrypted;
        },
        async saveUserTimestamp(old_json, new_json) {
          try {
            let form = {
              from_path: this.$route.path,
              from_name: this.$route.name,
              user_id: this.user.id,
              old_json: old_json ? JSON.stringify(old_json) : null,
              new_json: JSON.stringify(new_json),
            };
            await axios.post(`/user_timestamps`, form);
          } catch (error) {
            console.log(error);
          }
        },
        // Admin panel module access, as set per position (see panelModules.js).
        // action: view | add | edit | delete; keys: a module key or several
        canDo(keys, action = "view") {
          // A backend admin works inside the company they have switched to
          if (this.roleName === "BACKEND ADMIN" && this.company.id == null) return false;
          return canDoModule(this.user, keys, action);
        },
        canAccess(key) {
          return this.canDo(key, "view");
        },
        canAccessAny(keys = []) {
          return keys.some((key) => this.canAccess(key));
        },
        visible_to(users = []) {
          return users.some((role) => {
            return (
              this.roleName === role ||
              (this.roleName === "BACKEND ADMIN" &&
                role === "BACKEND ADMIN" &&
                this.company.id != null) ||
              this.positionName === role
            );
          });
        },
        isUnAuthorised() {
          this.$root.$emit("unauthorised");
        },
        isShowPopUP(title, subTitle, type = "error") {
          console.log("mixin: " + title);
          this.$root.$emit("showPopUp", {
            title,
            subTitle,
            type
          });
        },
        isDeletePage() {
          let response = false;
          if (this.$route.query.open_trash) {
            response = true;
          }
          return response;
        },
      },
      computed: {
        ...mapGetters({
          authenticated: "auth/authenticated",
          user: "auth/user",
          company: "auth/company",
          errors: "errors/getErrors",
          status: "errors/getStatus",
          baseUrl: "settings/getBaseUrl",
          mediaUrl: "settings/getMediaUrl",
          rowsPerPage: "settings/getRowsPerPage",
          roleName: "auth/roleName",
          positionName: "auth/positionName",
        }),
      },
    });
  },
};

Vue.use(mixin);
